import React, { useState , useEffect } from 'react'
import styled from "styled-components";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby"
import { BLOCKS, MARKS, INLINES } from "@contentful/rich-text-types"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { GatsbyImage } from "gatsby-plugin-image";
import Moment from 'react-moment'
import Carousel2 from '../ui/carousel2'

import Container, { Row, Half, Full, Third, TwoThird } from "../layout/container"
import Sidemenu from "../layout/sidebar";
import Crossfade from '../ui/crossfade';

const Section = styled.section`
  background: ${(props) => props.theme.colors.white};
  padding: 3rem 0 3rem;
  @media only screen and (max-width: ${props => props.theme.breakpoints.phone}) {
      padding: 0rem 0 3rem;
  }
  h3 {
    font-family: ${(props) => props.theme.fontGreen};
    letter-spacing: 0.05rem;
    font-size 3rem;
    @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
      font-size 2rem;
    }
    margin: 0;
    position: relative;
    text-transform: uppercase;
    margin-bottom: 0;
  }
  aside {
    display: none;
    .future {
        opacity: 1;
    }
    .proposal {
        opacity: 0.5;
    }
    .collab {
        opacity: 0.5;
    }
    .about {
        opacity: 0.5;
    }
    .feedback {
        opacity: 0.5;
    }
    @media screen and (min-width: ${props => props.theme.breakpoints.tablet}) {
      display: block;
    }
  }
`;



const Button = styled(Link)`
    font-size: 1rem;
    padding: 1rem 0;
    text-align: center;
    margin: 1rem 0;
    border: 2px solid #00FFB4;
    color: #3C3C3B;
    -webkit-text-decoration: none;
    text-decoration: none;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    z-index: 3;
    position: relative;
    width: 100%;
  &:hover {
    background: transparent;
    border: 2px solid ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.white};
  }
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    padding: 0.5rem 2rem;
    font-size: 1.5rem;
  }
`
const HomeRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
    flex-direction: column-reverse;
    margin-bottm: 2rem;
  }
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    flex-direction: column-reverse;
    margin-bottom: 2rem;
  }
`

const ImageBlock = styled.div`
  //padding: 0 2rem;
`

const Credit = styled.div`
  padding-left: 1rem;
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    padding-left: 0;
    padding-top: 1rem;
  }
  p {
    font-size: 0.6rem;
    padding-bottom: 0.2rem;
    margin: 0;
  }
`

const HomeBlock = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  .margin {
    margin-bottom: -2rem;
    @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
      margin-bottom: -1rem;
    }
  }
  .carousel {
    margin-top: auto;
  }
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    margin-bottom: 2rem;
  }
  @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
    margin-bottom: 2rem;
  }
`

const HomeCta = styled.div`
    border-top: 3px solid ${props => props.theme.colors.primary};
    text-align: center;
    padding: 10rem 0 6rem;
    margin-top: 3rem;
    h2 {
        padding: 0;
        margin: 0;
    }
    p {
        display: block;
        margin: 0;
        padding: 0;
        a {
          text-decoration: none;
          border-bottom: 1px solid ${props => props.theme.colors.primary};;
        }
    }
`

const Info = styled.div`
    p {
      //margin: 0;
      a {
        text-decoration: none;
        border-bottom: 1px solid ${props => props.theme.colors.primary};;
      }
    }
`

const HalfPageChange = styled.div`
  width: 48%;
  @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
    width: 100%;
  }
`




const options: any = {
  renderMark: {
    [MARKS.CODE]: (embedded: any) => (
      <div dangerouslySetInnerHTML={{ __html: embedded }} />
    ),
  },
  renderNode: {
    "embedded-asset-block": (node) => {
      const alt = node.data.target.fields.title["en-GB"];
      const url = node.data.target.fields.file["en-GB"].url;
      return <img alt={alt} src={url} />;
    },
    [INLINES.HYPERLINK]: (node) => {
      return <a href={node.data.uri} rel="noopener noreferrer">{node.content[0].value}</a>;
    },
    // [INLINES.ENTRY_HYPERLINK]: (node, children) => {
    //   // If you are using contenful.js sdk, the referenced entry is resolved
    //   // automatically and is available at `node.data.target`.
    //   //const referencedEntry = getEntryWithId(node.data.target.sys.id);
    //   //console.log(node.data.target);
    //   return <a href={`/pages/${node.data.target.sys.fields}`}>{children}</a>;
    // },

  },
};



const Home = () => {
    const data = useStaticQuery(graphql`{
  contentfulHomePage {
    homePageTitle
    homePageInfo {
      raw
    }
    homeCallToActionTitle
    homeCallToActionCopy {
      raw
    }
  }
  file(relativePath: {eq: "market-arch.jpeg"}) {
    childImageSharp {
      gatsbyImageData(width: 700, layout: CONSTRAINED)
    }
  }
}
`)
    var dates = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    var [date,setDate] = useState(new Date());
    console.log(data.contentfulHomePage.homePageInfo.raw)
    useEffect(() => {
        var timer = setInterval(()=>setDate(new Date()), 1000 )
        return function cleanup() {
            clearInterval(timer)
        }
    
    });
    let longDate = date.toLocaleDateString("en-UK", dates);
    longDate = longDate.substring(0, longDate.length-4);
  return (
    <Section id="home">
      <Container>
        <HomeRow>
          <HalfPageChange>
            {/* <ImageBlock>
                <GatsbyImage image={data.file.childImageSharp.gatsbyImageData} /> 
            </ImageBlock> */}
            <Crossfade />
          </HalfPageChange>
          <HalfPageChange>
              <HomeBlock>
                <Info>
                  <h3 className="margin">{longDate}</h3>
                  <p>{renderRichText(data.contentfulHomePage.homePageInfo, options)}</p>
                </Info>
                <div className="carousel">
                  <Carousel2 />
                </div>
              </HomeBlock>
          </HalfPageChange>
        </HomeRow>
        <Row>
            <Full>
                <HomeCta>
                  <h2>{data.contentfulHomePage.homeCallToActionTitle}</h2>
                  <p>{renderRichText(data.contentfulHomePage.homeCallToActionCopy, options)}</p>
                </HomeCta>
            </Full>
        </Row>
      </Container>
    </Section>
  );
};

export default Home;